import { Injectable } from '@angular/core';
declare var Persona: any;
import { LoaderService } from 'src/app/services/interceptor/loader.service';
import { environment } from 'src/environments/environment';
import { MainService } from 'src/app/services/main/main.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ContractDialogComponent } from 'src/app/pages/contract/contract-modal/contract-modal.component';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { SocketsService } from '../shared/socket.service';
import { PlaidService } from '../plaid/plaid.service';
import { take } from 'rxjs/operators';
import { getUserProfile, getUserProfiles, setUserProfiles } from 'src/app/core/session';
@Injectable({
  providedIn: 'root'
})
export class PersonaService {
  constructor(
    private mainService: MainService,
    public loaderService: LoaderService,
    public dialog: MatDialog,
    public _socket: SocketsService,
    public _plaid: PlaidService,
    public auth: AuthService
  ) {
  }
  personaVerificationError = false;

  openPersonaAddBankModal() {
    let userProfileData = getUserProfile();
    let going_to = '';

    // this.dialog.open(ContractDialogComponent, {
    //   width: '500px',
    //   panelClass: 'rightFullDialog',
    //   data: {
    //     type: 56,
    //     title: 'Add Bank'
    //   }
    // }).afterClosed().pipe(take(1)).subscribe((data:any)=>{
    //   if(data == 1) {
    //     this.openPersonaAddBankModal();
    //   }
    // });

    // return


    if (userProfileData.business_verification_state == 'other_info_updated') {
      //No Need to add bank details
      console.log('No Need to add bank details');
    } else if (userProfileData.business_verification_state == 'persona_verified') {
      going_to = 'Fill business other details';
      //To fill other details for finish registeration
      this.dialog.open(ContractDialogComponent, {
        width: '500px',
        panelClass: 'rightFullDialog',
        data: {
          type: 57,
          title: 'Business Information'
        }
      });
    } else if (userProfileData.business_verification_state == 'persona_failed') {
      going_to = 'support due to failed persona verification';
      this.dialog.open(SimpleDialogComponent, {
        width: '520px',
        panelClass: 'simpleDialog',
        data: {
          type: 44,
          is_ar: 0
        }
      });
    } else if (userProfileData.business_verification_state == 'bank_added') {
      going_to = 'verify using persona';
      //To Verify Persona
      this.mainService.personaButton$.next(false);
      this.loaderService.show();
      // this.openKYBPersona();

      setTimeout(() => {
        this.dialog.open(ContractDialogComponent, {
          width: '500px',
          panelClass: 'rightFullDialog',
          data: {
            type: 57,
            title: 'Business Information'
          }
        }).afterClosed().pipe(take(1)).subscribe((data: any) => {
          this.mainService.personaButton$.next(true);
        });
      this.loaderService.hide();
      }, 1000);

          } else if (userProfileData.business_verification_state == 'registered') {
      going_to = 'add bank details';
      if (userProfileData && userProfileData.is_ach_required == 1 && userProfileData.auth_bank_status != 'verified') {
        this._plaid.createLinkTokenPlaid({ doctor_id: userProfileData.doctor_id })
      } else {
        //To add bank account
        this.dialog.open(ContractDialogComponent, {
          width: '500px',
          panelClass: 'rightFullDialog',
          data: {
            type: 56,
            title: 'Add Bank'
          }
        }).afterClosed().subscribe((data:any)=>{
          if(data == 1) {
            this.openPersonaAddBankModal();
          }
        });
      }
    } else if (userProfileData.business_verification_state == 'verification_pending') {
      going_to = 'verify using Stripe';
      // To Verify Persona
      // return new Promise((resolve, reject) => {
      const obj = {
        access_token: localStorage.getItem('token')
      };
      this.mainService.api(obj, 'get_verification_link', false).subscribe((resp: any) => {
        if (resp.is_error && (resp.msg || resp.err)) {
          this.mainService.customPopups(resp.msg || resp.err, 1);
        } else {
          if (resp.data.client_secret) {
            this.mainService.stripe.verifyIdentity(resp.data && resp.data.client_secret).then(response => {
              console.log(JSON.stringify(response));
              // if(response.code == "session_cancelled" || (response.error && (response.error.code == "session_does_not_exist" || response.error == null))) {
              this.auth.accessTokenLogin();
              // }
            });
          }
          if(resp?.data?.status && resp?.data?.status == 'verified') {
            this.auth.accessTokenLogin();
          }
        }
      });
      // });
    }
    if (this._socket.socket && this._socket.socket.connected) {
      this._socket.socket.emit('finish_registeration', {
        url: window.location.href,
        role_id: userProfileData.role_id,
        first_name: userProfileData.doctor_first_name,
        last_name: userProfileData.doctor_last_name,
        going_to: going_to,
        doctor_id: userProfileData.doctor_id
      });
    }
  }

  openKYBPersona() {
    let doctorInfo = getUserProfiles();
    const persona_inquiry_id = localStorage.getItem('userProfileData') ? (getUserProfile().persona_inquiry_id) : null;
    const client = new Persona.Client({
      inquiryId: persona_inquiry_id,
      referenceId: doctorInfo && doctorInfo[0] && doctorInfo[0].doctor_email ? doctorInfo[0].doctor_email : null,
      templateId: persona_inquiry_id ? null : this.mainService.persona_template_id,
      environment: environment.persona_env,
      "fields": {
        "business-name": doctorInfo[0] && doctorInfo[0].practice_name ? doctorInfo[0].practice_name : null,
        // "business-tax-identification-number": doctorInfo[0] && doctorInfo[0].tin ? doctorInfo[0].tin.trim().substring(0, 2) + '-' + doctorInfo[0].tin.trim().substring(2) : null,
      },
      onReady: () => client.open(
        this.loaderService.hide()
      ),
      onEvent: async (name, meta) => {
        if (name == 'start') {
          this.setInquiryToBackend(meta, persona_inquiry_id, name)
        }
        /* if (name == 'document-upload') {
          this.setInquiryToBackend(meta, localStorage.getItem('userProfileData') ? (getUserProfile().persona_inquiry_id) : null, name).then((resp) => {
            if (this.personaVerificationError) {
              client.cancel(true);
            }
          });
        }
        if (name == 'selfie-camera-select') {
          this.setInquiryToBackend(meta, localStorage.getItem('userProfileData') ? (getUserProfile().persona_inquiry_id) : null, name).then((resp) => {
            if (this.personaVerificationError) {
              client.cancel(true);
            }
          });
        }
        if (name == 'document-camera-select') {
          this.setInquiryToBackend(meta, localStorage.getItem('userProfileData') ? (getUserProfile().persona_inquiry_id) : null, name).then((resp) => {
            if (this.personaVerificationError) {
              client.cancel(true);
            }
          });
        }
        if (name == 'one-time-link-sent') {
          this.setInquiryToBackend(meta, localStorage.getItem('userProfileData') ? (getUserProfile().persona_inquiry_id) : null, name).then((resp) => {
            if (this.personaVerificationError) {
              client.cancel(true);
              return false;
            }
          });
        }
        if (name == 'one-time-link-start') {
          this.setInquiryToBackend(meta, localStorage.getItem('userProfileData') ? (getUserProfile().persona_inquiry_id) : null, name).then((resp) => {
            if (this.personaVerificationError) {
              client.cancel(true);
            }
          });

        }
        if (name == 'one-time-link-exit') {
          this.setInquiryToBackend(meta, localStorage.getItem('userProfileData') ? (getUserProfile().persona_inquiry_id) : null, name).then((resp) => {
            if (this.personaVerificationError) {
              client.cancel(true);
            }
          });
        } */
      },
      onComplete: (res: any) => {
        let personaKycResponse = res;
        console.log('personaKycResponse', personaKycResponse);
        if (personaKycResponse && personaKycResponse.status && personaKycResponse.status == 'completed') {
          let practice_address1 = personaKycResponse && personaKycResponse.fields && personaKycResponse.fields['business-address-street-1'] ? personaKycResponse.fields['business-address-street-1'].value : ' ';
          let practice_address2 = personaKycResponse && personaKycResponse.fields && personaKycResponse.fields['business-address-street-2'] && personaKycResponse.fields['business-address-street-2'].value != null ? personaKycResponse.fields['business-address-street-2'].value : ' ';
          let doctor_address1 = personaKycResponse && personaKycResponse.fields && personaKycResponse.fields['address-street-1'] ? personaKycResponse.fields['address-street-1'].value : ' ';
          let doctor_address2 = personaKycResponse && personaKycResponse.fields && personaKycResponse.fields['address-street-2'] && personaKycResponse.fields['address-street-2'].value != null ? personaKycResponse.fields['address-street-2'].value : ' ';
          let data = {
            access_token: localStorage.getItem('token'),
            inquiry_id: personaKycResponse.inquiryId,
            is_web_panel: 1,
            status: personaKycResponse.status,
            practice_address: practice_address1 + ' ' + practice_address2,
            practice_postal_code: personaKycResponse && personaKycResponse.fields && personaKycResponse.fields['business-address-postal-code'] ? personaKycResponse.fields['business-address-postal-code'].value : '',
            practice_name: personaKycResponse && personaKycResponse.fields && personaKycResponse.fields['business-name'] ? personaKycResponse.fields['business-name'].value : '',
            practice_tin: personaKycResponse && personaKycResponse.fields && personaKycResponse.fields['business-tax-identification-number'] ? personaKycResponse.fields['business-tax-identification-number'].value : '',
            doctor_address: doctor_address1 + ', ' + doctor_address2,
            doctor_postal_code: personaKycResponse && personaKycResponse.fields && personaKycResponse.fields['address-postal-code'] ? personaKycResponse.fields['address-postal-code'].value : '',
            date_of_birth: personaKycResponse && personaKycResponse.fields && personaKycResponse.fields['birthdate'] ? personaKycResponse.fields['birthdate'].value : '',
            business_type: personaKycResponse && personaKycResponse.fields && personaKycResponse.fields['business-type'] ? personaKycResponse.fields['business-type'].value : ''
          }
          this.mainService.api(data, `verify_bank_using_persona_data`, false,)
            .subscribe(response => {
              if (response.is_error) {
                this.mainService.customPopups(response.err, 1);
                this.loaderService.hide();
              } else {
                this.loaderService.hide();
                this.auth.accessTokenLogin();
                let userProfileData = getUserProfiles();
                userProfileData[0].business_verification_state = 'persona_verified';
                setUserProfiles(userProfileData);
                setTimeout(() => {
                  this.dialog.open(ContractDialogComponent, {
                    width: '500px',
                    panelClass: 'rightFullDialog',
                    data: {
                      type: 57,
                      title: 'Business Information'
                    }
                  });
                }, 1000);
              }
            })
        } else {
          this.mainService.customPopups('You have crossed verification limit for the day, please try after 24 hours.', 1);
        }
      },
      onCancel: (res: any) => {
        console.log('on cancel res -->>>>', res);
        // this.mainService.personaButton = false;
        this.mainService.personaButton$.next(true);
      },
      onError: (error) => {
        console.log('error ----->', error);
        if (error && error.code == 'unauthenticated') {
          let data = {
            access_token: localStorage.getItem('token'),
            inquiry_id: persona_inquiry_id,
            is_inquiry_expired: 1
          };
          this.mainService.api(data, `verify_bank_using_persona_data`, false,)
            .subscribe(response => {
              this.loaderService.hide();
              this.auth.accessTokenLogin();
            });
        }
      }
    });
  }

  setInquiryToBackend(meta, persona_inquiry_id, type) {
    return new Promise((resolve, reject) => {
      /* if (type == 'document-upload' || type == 'selfie-camera-select' || type == 'document-camera-select' || type == 'one-time-link-sent' || type == 'one-time-link-start' || type == 'one-time-link-exit') {
        let data = {
          access_token: localStorage.getItem('token'),
          inquiry_id: persona_inquiry_id,
          type: type
        };
        return this.mainService.api(data, `verify_bank_using_persona_data`, false,)
          .subscribe(response => {
            this.loaderService.hide();
            if (response.is_error) {
              this.personaVerificationError = true;
              this.auth.accessTokenLogin();
              this.mainService.customPopups(response.err, 1);
              return resolve('error')
            }
          });
      } */
      if (meta && meta.inquiryId && !persona_inquiry_id && (type == 'start')) {
        let data = {
          access_token: localStorage.getItem('token'),
          inquiry_id: meta.inquiryId,
          type: type
        };
        this.mainService.api(data, `verify_bank_using_persona_data`, false,)
          .subscribe(response => {
            this.loaderService.hide();
            this.auth.accessTokenLogin();
          });
      }
    })
  }
}
